<ng-template pTemplate="header">
  <span class="text-xl font-bold">{{ question_title }}</span>
</ng-template>
<form [formGroup]="frm">
  <!-- <div *ngFor="let f of frm.controls['services'].controls" class="border">
        <div [formGroup]="f"> -->
  <div class="field">
    <label>Codice*</label>
    <input
      type="text"
      formControlName="identifier"
      pInputText
      type="text"
      class="w-full" />
  </div>
  <div class="field">
    <label>Nome*</label>
    <input
      type="text"
      formControlName="name"
      pInputText
      type="text"
      class="w-full" />
  </div>
  <div class="field">
    <label>Descrizione</label>
    <textarea
      rows="3"
      class="w-full"
      pInputText
      formControlName="description"
      pInputText
      class="w-full"></textarea>
  </div>
  <!-- </div>
    </div> -->
  <!-- <div class="flex justify-content-center">
        <p-button (click)="add()" styleClass="butt" [rounded]="true"><span>Aggiungi</span></p-button>
    </div> -->
</form>
<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      (onClick)="close()"
      label="Annulla"
      [text]="true"
      styleClass="butt red"
      [rounded]="true"></p-button>
    <p-button
      [label]="button_ok_title"
      (onClick)="save()"
      styleClass="butt"
      [rounded]="true"
      [disabled]="frm.invalid"></p-button>
  </div>
</div>
